import { ReactNode, Ref } from 'react'

import { gt } from '~/locale'

import { ContentWrapper, Section, TitleIcon, TitleText, TitleWrapper } from './ProductPageSectionShards'

type RestaurantPageSectionProps = {
  id: string
  icon?: string
  children: ReactNode
  title: string
  contentRef?: Ref<HTMLDivElement>
}

export const ProductPageSection = ({ id, children, icon, title, contentRef }: RestaurantPageSectionProps) => {
  return (
    <Section id={id}>
      <TitleWrapper>
        {icon && <TitleIcon icon={icon} />}
        <TitleText>{gt.tp('ProductPage', title)}</TitleText>
      </TitleWrapper>
      <ContentWrapper ref={contentRef}>{children}</ContentWrapper>
    </Section>
  )
}
